import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import type { Movie } from '@/mocks/movies';

interface MovieSectionProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  viewAllLink?: string;
  viewAllLabel?: string;
}

export default function MovieSection({ title, subtitle, movies, viewAllLink, viewAllLabel }: MovieSectionProps) {
  return (
    <section className="py-8 md:py-12">
      <div className="px-4 md:px-6 lg:px-8">
        <div className="max-w-[1440px] mx-auto">
          <div className="flex items-end justify-between mb-6">
            <div>
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-100">
                {title}
              </h2>
              {subtitle && (
                <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>
              )}
            </div>
            {viewAllLink && (
              <Link
                to={viewAllLink}
                className="flex items-center gap-1 text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {viewAllLabel || '查看全部'}
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </Link>
            )}
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
            {movies.slice(0, 6).map((movie) => (
              <MovieCard
                key={movie.id}
                id={movie.id}
                title={movie.title}
                poster={movie.poster}
                year={movie.year}
                rating={movie.rating}
                quality={movie.quality}
                category={movie.category}
                genres={movie.genres}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}